import { formatLocale } from "d3-format";

export const px = (str) => `${str}px`;
export const deg = (str) => `${str}deg`;
export const percent = (str) => `${str}%`;
export const celcius = (str) => `${str} °C`;

export const getChangeInPercent = (value, baselineValue) => (100 * (value - baselineValue)) / baselineValue;

export const daysBetween = (date1, date2) => {
	// The number of milliseconds in one day
	const ONE_DAY = 1000 * 60 * 60 * 24;
	// Calculate the difference in milliseconds
	const differenceMs = Math.abs(date1 - date2);
	// Convert back to days and return
	return Math.round(differenceMs / ONE_DAY);
};

export const stringToDate = (_date, _format, _delimiter) => {
	const formatLowerCase = _format.toLowerCase();
	const formatItems = formatLowerCase.split(_delimiter);
	const dateItems = _date.split(_delimiter);
	const monthIndex = formatItems.indexOf("mm");
	const dayIndex = formatItems.indexOf("dd");
	const yearIndex = formatItems.indexOf("yyyy");
	// D: the following three lines led the code to be
	// off by one hour compared to `new Date('1999-01-01')`
	//
	// let month = parseInt(dateItems[monthIndex], 10);
	// month -= 1;
	// const formatedDate = new Date(dateItems[yearIndex], month, dateItems[dayIndex]);
	// return formatedDate;
	return new Date(`${dateItems[yearIndex]}-${dateItems[monthIndex]}-${dateItems[dayIndex]}`);
};

const locale = formatLocale({
	decimal: ",",
	thousands: ".",
	grouping: [3],
});

export function formatInt(postfix = "") {
	return (x) => fixThousandSep(locale.format(",d")(x)) + postfix;
}

export function formatFloat(
	digits = 1,
	postfix = "",
	signed,
	multiplier = 1,
	decimal = false,
	adaptive = false
) {
	return function (x) {
		let ds = digits;
		if (adaptive) {
			if (Math.abs(x * multiplier) < 1) ds += 1;
			if (Math.abs(x * multiplier) < 0.1) ds += 1;
			if (Math.abs(x * multiplier) < 0.01) ds += 1;
			if (Math.abs(x * multiplier) < 0.001) ds += 1;
		}
		let s = locale.format(`${signed ? "+" : ""},.${ds}f`)(x * multiplier);
		s = fixThousandSep(s);
		if (decimal) {
			s = s.replace(/,0*$/, "");
			if (s.indexOf(",") > -1) {
				s = s.replace(/0*$/, "");
			}
		}
		s += postfix;
		return s;
	};
}

function fixThousandSep(x) {
	const s = x.split(".");
	if (s.length !== 2) return x;
	if (s[0].length !== 1) return x;
	return x.replace(".", "");
}

const monthNamesShort = [
	"Jan",
	"Feb",
	"Mär",
	"Apr",
	"Mai",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Okt",
	"Nov",
	"Dez",
];

const monthNamesFull = [
	"Januar",
	"Februar",
	"März",
	"April",
	"Mai",
	"Juni",
	"Juli",
	"August",
	"September",
	"Oktober",
	"November",
	"Dezember",
];

export const zeroPad = (x) => `00${x}`.slice(-2);

export function formatDay(date) {
	const day = date.getDate();
	const monthIndex = date.getMonth();
	const year = date.getFullYear();
	return `${zeroPad(day)}.${zeroPad(monthIndex + 1)}.${year}`;
}

export function formatDayShort(date) {
	const day = date.getDate();
	const monthIndex = date.getMonth();
	return `${day}.${monthIndex + 1}.`;
}

export function formatDayISO(date) {
	const day = date.getDate();
	const monthIndex = date.getMonth();
	const year = date.getFullYear();
	return `${year}-${zeroPad(monthIndex + 1)}-${zeroPad(day)}`;
}

/*
export function formatMonth(date) {
  const monthIndex = date.getMonth();
  const year = date.getFullYear();
  return `${monthNames[monthIndex]} ${year}`;
}
*/
export function formatMonth(date) {
	const monthIndex = date.getMonth();
	const year = date.getFullYear();
	return `${zeroPad(monthIndex + 1)}.${year}`;
}

export function formatOnlyMonth(date) {
	const monthIndex = date.getMonth();
	return monthNamesShort[monthIndex];
}

export function formatOnlyMonthFull(date) {
	const monthIndex = date.getMonth();
	return monthNamesFull[monthIndex];
}

export function formatYear(date) {
	const year = date.getFullYear();
	return `${year}`;
}

export function formatSince(what) {
	return function (date) {
		return `${date.getTime()}${what}`;
	};
}

export function formatQuarter(date) {
	const month = date.getMonth() + 1;
	const q = Math.ceil(month / 3);
	const year = date.getFullYear();
	return `Q${q} ${year}`;
}

export function deepcopy(x) {
	return JSON.parse(JSON.stringify(x));
}
